module.exports = __webpack_public_path__ + "img/icon8.ccc6b09f.png";